import get from "lodash/get";
import getConfig from "./config";

let log = {
    actions: []
}

export const actionLogMiddleware = storeAPI => next => action => {
    const maxSize = get(getConfig(), "errorReporting.maxActionLog", 100)

    log.actions.push(action)
    log.actions = log.actions.splice( maxSize * -1 );

    return next(action)
}

export const getActionLog = () => {
    return log.actions;
}